import constants from "./constants";
import { EventBus } from './services/event-bus';
const TypeaheadUtils = {

	updateTypeAheadData(paramId) {
		var self = this;
		if (paramId == undefined) {
			paramId = "";
		}
		$("input[data_ta_src]:not([readonly])").each(function () {
			self.manageTypeAheadField(this, paramId);
		});
	},
	validateValueOfTypeahead() {
		var isUnique = true;
		$("input[data_ta_src]").each(function () {
			const name = name
			var namess;
			const forceSelect = $(this).attr("data_force_select");
			const value = $(this).val().toLowerCase().trim();
			const data_ta_src = $(this).attr("data_ta_src");
			if (typeof forceSelect !== typeof undefined && forceSelect == "false" && value != "" && data_ta_src != "") {
			    var strs = JSON.parse(data_ta_src);
				$.each(strs, function (i, str) {
			  		var dispField = str.value + " - " + str.name;
			  		if (isUnique && (str.value.toLowerCase() == value || dispField.toLowerCase() == value)) {
						isUnique = false;
			  		}
				});
				if (!isUnique) {
					return isUnique;
				}
			}
		});
		return isUnique;
  	},
	validateTypeaheadMinValues() {
		const self = this;
		let isValid = true;
		$("input[data_ta_src]").each(function () {
			isValid = self.validateMinLength(this) && isValid;
		});
		return isValid;
	},
	validateMinLength(inputField) {
		const inputLength = parseInt($(inputField).val().toLowerCase().trim().length);
		if (inputLength === 0 || $(inputField).attr("minlength") === undefined || inputLength >= $(inputField).attr("minlength")) {
			return true;
		}
		return false;
	},
	removeTypeAheadForParent(currentObj) {
		$(currentObj).find("input[data_ta_src]").each(function () {
			var dataFieldName = $(this).attr("data-datafield");
			if (dataFieldName && dataFieldName != "") {
				var typeAheadURL = $(this).attr("data_src_url");
				if (typeAheadURL && typeAheadURL != "" && $(this).typeahead("val") != null) {
					$(this).typeahead("destroy");
					$(this).unbind();
				}
			}
		});
	},
	manageTypeAheadField(currentObj, paramId) {
		var dataPrefetch = $(currentObj).attr('data_prefetch');
		var compName = $(currentObj).attr('name');
		if (dataPrefetch == undefined || dataPrefetch == "" || dataPrefetch == "false") {
			if (paramId == "") {
				this.destroyTypeaheadElement(currentObj);
				this.getElementByName(compName).attr('data_ta_src', "[]");
				this.bindFieldTypeAheadOnFocus(compName);
				this.checkForTypeahead(compName);
				return;
			} else {
				return;
			}
		}

		var systemURL = $(currentObj).attr('data_src_url');
		var systemDataJSon = $(currentObj).attr('data_json');
		if (paramId != "") {
			var hasReference = this.hasFieldCurrentComponentReference(JSON.parse(systemDataJSon), paramId);
			if (!hasReference) {
				return;
			}
		}
		this.destroyTypeaheadElement(currentObj);
		var typeAheadUpdateRequired = this.checkTypeAheadDynamicData(JSON.parse(systemDataJSon), compName);
		if (!typeAheadUpdateRequired) {
			this.renderTypeAheadDataWithService(systemURL, compName);
		} else {
			systemDataJSon = JSON.parse(this.getElementByName(compName).attr('data_json'));
			this.renderTypeAheadDataField(systemDataJSon, compName);
		}
	},
	bindFieldTypeAheadOnFocus(id) {
		var self = this;
		var formObj = self.getElementByName(id);
		formObj.unbind("focus");
		formObj.bind('focus', function () {
			var systemURL = formObj.attr('data_src_url');
			var systemDataJSon = formObj.attr('data_json');
			var typeAheadUpdateRequired = self.checkTypeAheadDynamicData(JSON.parse(systemDataJSon), id);
			if (!typeAheadUpdateRequired) {
				self.renderTypeAheadDataWithService(systemURL, id);
			} else {
				systemDataJSon = JSON.parse(self.getElementByName(id).attr('data_json'));
				self.renderTypeAheadDataField(systemDataJSon, id);
			}
		});
	},
	renderTypeAheadDataField(serviceParameters, selectedWidget) {
		var self = this;
		var url = self.updateDynamicURL(serviceParameters, selectedWidget);
		self.renderTypeAheadDataWithService(url, selectedWidget);
	},
	recursiveSearchTypeAheadJSON(key, obj) {
		var results = [];
		try {
			// Handle null edge case.
			if (obj === null) {
				// nothing to do here
				return [];
			}
			// handle case of non-object, which will not be searched
			if (obj !== Object(obj)) {
				return [];
			}
			for (var iKey in obj) {
				if (obj.hasOwnProperty(iKey)) {
					if (iKey === key) {
						return obj[iKey];
					} else if (typeof obj[iKey] === 'object' && obj[iKey] !== null) {
						results = this.recursiveSearchTypeAheadJSON(key, obj[iKey]);
						if (results !== undefined) {
							return results;
						}
					}
				}
			}
		} catch (e) {
			return [];
		}
		return results;
	},
	getSplittedResultArray(dataField, responseData) {
		var resultArray = [];
		var splittedDataSource = dataField.split(".");
		if (splittedDataSource.length == 1 && responseData.hasOwnProperty(splittedDataSource[0])) {
			resultArray = responseData[splittedDataSource[0]];
		} else if (splittedDataSource.length == 1) {
			resultArray = this.recursiveSearchTypeAheadJSON(dataField, responseData);
		} else if (splittedDataSource.length > 1 && responseData.hasOwnProperty(splittedDataSource[0])) {
			resultArray = responseData[splittedDataSource[0]];
			for (var ind = 1; ind < splittedDataSource.length; ind++) {
				if (resultArray.hasOwnProperty(splittedDataSource[ind])) {
					resultArray = resultArray[splittedDataSource[ind]];
				} else {
					resultArray = [];
				}
			}
		}
		return resultArray;
	},
	renderTypeAheadDataWithService(systemURL, id) {
		var self = this;
		var fieldObj = this.getElementByName(id);
		var dataPrefetch = fieldObj.attr('data_prefetch');
		if (systemURL && systemURL != "" && id != undefined) {
			var serviceData = [];
			$.ajax({
				url: constants.BASE_URL + systemURL,
				type: 'get',
				dataType: 'json',
				contentType: 'application/json; charset=utf-8',
				success: function (responseData) {
					var dataField = fieldObj.attr('data_field');
					var dispField = fieldObj.attr('data_disp_field');
					var valueField = fieldObj.attr('data_value_field');

					if (dataField == null || dataField == "") {
						dataField = "data";
					}
					/*
					 * Currently in E5 we are using value as disp field and name as
					 * value field.
					 */
					if (dispField == null || dispField == "") {
						dispField = "value";
					}
					if (valueField == null || valueField == "") {
						valueField = "name";
					}

					if (responseData) {
						var resultArray = self.getSplittedResultArray(dataField, responseData);
						if (resultArray != null) {
							$.each(resultArray, function (i, infoData) {
								if (infoData[dispField] && infoData[valueField]) {
									serviceData.push({
										"name": infoData[dispField],
										"value": infoData[valueField],
										"dispField": infoData[valueField] + " - " + infoData[dispField]
									});
								}
							});
						}
					}
					self.getElementByName(id).attr('data_ta_src', JSON.stringify(serviceData));
					if (dataPrefetch != undefined && dataPrefetch == "true") {
						self.checkForTypeahead(id);
					}
				},
				error: function () {
					self.getElementByName(id).attr('data_ta_src', JSON.stringify(serviceData));
					if (dataPrefetch != undefined && dataPrefetch == "true") {
						self.checkForTypeahead(id);
					}
				}
			});
		}
	},
	hasFieldCurrentComponentReference(systemDataJSon, paramId) {
		var hasFieldCurrentComponentReference = false;
		if (systemDataJSon) {
			$.each(systemDataJSon, function (i, jsonValue) {
				if (jsonValue.paramFormValue && jsonValue.paramFormValue.trim() == paramId) {
					hasFieldCurrentComponentReference = true;
				}
			});
		}
		return hasFieldCurrentComponentReference;
	},
	checkTypeAheadDynamicData(systemDataJSon, id) {
		var self = this;
		var typeAheadUpdateRequired = false;
		if (systemDataJSon && id) {
			$.each(systemDataJSon, function (i, jsonValue) {
				if (jsonValue.paramFormValue && jsonValue.paramFormValue.trim() != "") {
					var formObj = self.getElementByName(jsonValue.paramFormValue);
					typeAheadUpdateRequired = true;
					if (formObj.length > 0) {
						jsonValue.paramValue = "";
						if (formObj.val().trim() != "") {
							jsonValue.paramValue = formObj.val();
							var attr = $(formObj).attr('data_ta_src');
							/*
							 * If the reference field is Typeahead
							 * field, get its value instead of
							 * display value
							 */
							if (typeof attr !== typeof undefined && attr !== false) {
								jsonValue.paramValue = self.getTypeAheadFieldValue($(formObj));
							}
						}
						self.bindBlurEventOfDynamicParam(jsonValue.paramFormValue);
					}

				}
			});
			if (typeAheadUpdateRequired) {
				self.getElementByName(id).attr('data_json', JSON.stringify(systemDataJSon));
			}
		}
		return typeAheadUpdateRequired;
	},
	bindBlurEventOfDynamicParam(paramId) {
		var self = this;
		var formObj = $('[name="' + paramId + '"]:not([readonly]');
		if (formObj) {
			formObj.unbind("change");
			formObj.bind('change', function () {
				if ($(this).val() != "") {
					var forceSelect = $(this).attr('data_force_select');
					if (typeof forceSelect !== typeof undefined && forceSelect == "true" && self.isFieldValueInValid($(this))) {
						$(this).val("");
					}
				}
				self.updateTypeAheadData(paramId);
			});

		}
	},
	typeaheadUIPatch(userinputid, bind) {
		var typeaheadTextbox = $("#" + userinputid + ".tt-input");
		if (typeaheadTextbox.length > 0) {
			var parentDivForComponent = typeaheadTextbox.closest("[id^='divForComponent']");
			if (bind) {
				parentDivForComponent.children("label").addClass("d-inline-block");
				if (parentDivForComponent.children("label").hasClass("col-md-3")) {
					parentDivForComponent.children(".twitter-typeahead").addClass("col-sm-12 col-md-9 px-0");
					typeaheadTextbox.removeClass("col-sm-12 col-md-9");
				}
				parentDivForComponent.children(".twitter-typeahead").addClass("d-inline-block");
			} else {
				parentDivForComponent.children("label").removeClass("d-inline-block");
				parentDivForComponent.children(".twitter-typeahead").removeClass("col-sm-12 col-md-9 px-0");
				if (parentDivForComponent.children("label").hasClass("col-md-3")) {
					typeaheadTextbox.addClass("col-sm-12 col-md-9");
				}
			}
		}
	},
	isTypeahead(userinputid) {
		var typeaheadSrc = this.getElementByName(userinputid).attr("data_ta_src");
		return typeof typeaheadSrc !== typeof undefined && typeaheadSrc != "";
	},
	checkForTypeahead(userinputid) {
		var typeaheadSrc = this.getElementByName(userinputid).attr("data_ta_src");
		var defaultSuggestion = this.getElementByName(userinputid).attr('data_defaultsuggestion');
		var minLength = 1;
		if (defaultSuggestion != undefined && defaultSuggestion != "" && defaultSuggestion == "true") {
			minLength = 0;
		}

		if (typeof typeaheadSrc !== typeof undefined && typeaheadSrc != "") {
			if(this.getElementByName(userinputid).typeahead && this.getElementByName(userinputid).typeahead("val") != null) {
				this.getElementByName(userinputid).typeahead("destroy");
			}
			
			this.bindTypeAhead(this.getElementByName(userinputid), minLength);
			this.setTypeAheadDispField(this.getElementByName(userinputid));
		}
	},
	destroyTypeaheadElement(obj) {
		if ($(obj).typeahead && $(obj).typeahead("val") != null) {
			$(obj).typeahead("destroy")
		}
	},
	substringMatcher(currentObj) {
		return function findMatches(q, cb) {
			var matches = [];
			var strs = JSON.parse(currentObj.attr("data_ta_src"));
			var substrRegex = new RegExp(q, "i");
			$.each(strs, function (i, str) {
				if (substrRegex.test(str.name) || substrRegex.test(str.value)
					|| substrRegex.test(str.value + " - " + str.name)) {
					matches.push(str);
				}
			});
			cb(matches);
		};
	},
	bindTypeAhead(eleObj, minLength) {
		var self = this;
		var mosaicEle = $(eleObj[0])
		var typeaheadEle = $(eleObj[0])
		var maxSuggestionsAttr = $(mosaicEle).attr('data_max_suggestion');
		var maxSuggestions = 20;
		if (typeof maxSuggestionsAttr !== typeof undefined && maxSuggestionsAttr != "" && parseInt(maxSuggestionsAttr) > 0) {
			maxSuggestions = parseInt(maxSuggestionsAttr);
		}
		$(typeaheadEle).typeahead(
			{
				minLength: minLength,
				highlight: true
			},
			{
				name: 'typeahead',
				display: 'dispField',
				minLength: 0,
				limit: maxSuggestions,
				source: self.substringMatcher(mosaicEle),
				templates: {
					suggestion: function (data) {
						return '<p><strong>' + data.value + '</strong> – '
							+ data.name + '</p>';
					}
				},
			}
		);
		$(typeaheadEle).unbind('typeahead:close')
		$(typeaheadEle).bind('typeahead:close', function (ev) {
			if ($(this).val() != "") {
				var typeAheadField = $(this);

				var forceSelect = $(mosaicEle).attr('data_force_select');
				var isInValid = (typeof forceSelect !== typeof undefined && forceSelect == "true" && self.isFieldValueInValid($(mosaicEle)));
				if (isInValid == true) {
					$(this).typeahead('val', '');
				} else {
					$(this).typeahead('val', $(this).val());
					if ($(this).val() != '') {
						typeAheadField.removeAttr("invalid");
					}
				}
				typeAheadField.val($(this).val());
				typeAheadField.trigger('change');
				self.validateTypeahead(eleObj[0]);
			}
		});
		eleObj[0].addEventListener('input', () => {
			self.validateTypeahead(eleObj[0]);
		})
		$(typeaheadEle).after('<div class="mfc-invalid-feedback"></div>');
	},
	validateTypeahead(inputField) {
		let isUnique = true;
		const forceSelect = $(inputField).attr("data_force_select");
		const value = $(inputField).val().toLowerCase().trim();
		const data_ta_src = $(inputField).attr("data_ta_src");
		const invalidFeedbackElement = $(inputField).next("div.mfc-invalid-feedback");
		if (typeof forceSelect !== typeof undefined && forceSelect == "false" && value != "" && data_ta_src != "") {
			var strs = JSON.parse(data_ta_src);
			$.each(strs, function (i, str) {
				var dispField = str.value + " - " + str.name;
				if (isUnique && (str.value.toLowerCase() == value || dispField.toLowerCase() == value)) {
					isUnique = false;
				}
			});
			if (!isUnique) {
				$(inputField).addClass('ms-is-invalid');
				$(invalidFeedbackElement).text(`${$(inputField).closest("div.mfc-input-group").parent().find('.labelDiv').text().substring(0,$(inputField).closest("div.mfc-input-group").parent().find('.labelDiv').text().length - 4)} must be unique`)
				return;
			}
		}
		if(!this.validateMinLength(inputField)) {
			$(inputField).addClass('ms-is-invalid');
			return;
		}
		$(inputField).removeClass('ms-is-invalid');
	},
	isFieldValueInValid(currentObj) {
		var isInValid = true;
		if ($(currentObj).attr("data_ta_src") != "") {
			var strs = JSON.parse($(currentObj).attr("data_ta_src"));
			var currentValue = $(currentObj).val();
			$.each(strs, function (i, str) {
				var dispField = str.value + " - " + str.name;
				if (str.value == currentValue || (dispField == currentValue)) {
					isInValid = false;
				}
			});
		}
		return isInValid;
	},
	getElementByName(objName) {
		return $('[name="' + objName + '"]').not("td");
	},
	getTypeAheadFieldValue(currentObj) {
		if ($(currentObj).attr("data_ta_src") == "") {
			return $(currentObj).val();
		}
		var strs = JSON.parse($(currentObj).attr("data_ta_src"));
		var currentValue = $(currentObj).val();
		var actualValue = currentValue;
		$.each(strs, function (i, str) {
			var dispField = str.value + " - " + str.name;
			if (str.value == currentValue || (dispField == currentValue)) {
				actualValue = str.value;
			}
		});
		return actualValue;
	},
	getTypeAheadFieldDispValue(currentObj) {
		if ($(currentObj).attr("data_ta_src") == "") {
			return $(currentObj).val();
		}
		var strs = JSON.parse($(currentObj).attr("data_ta_src"));
		var currentValue = $(currentObj).val();
		if (currentValue == "") {
			return "";
		}
		var actualValue = currentValue;
		$.each(strs, function (i, str) {
			var dispField = str.value + " - " + str.name;
			if (str.value == currentValue || (dispField == currentValue)) {
				actualValue = dispField;
			}
		});
		return actualValue;
	},
	setTypeAheadDispField(currentObj) {
		if ($(currentObj).val() != "") {
			var val = this.getTypeAheadFieldDispValue($(currentObj));
			$(currentObj).val(val);
			$(currentObj).typeahead('val', val);
		}
	},
	// unbindTypeAhead() {
	// 	var self = this;
	// 	$("*[data_ta_src]").each(function () {
	// 		$(this).val(self.getTypeAheadFieldValue($(this)));
	// 		$(this).typeahead("destroy");
	// 		$(this).unbind();
	// 	});
	// },
	updateTypeAheadJsonForRepeatable(parentObj) {
		var self = this;
		$(parentObj).find("[data_src_url]").not('input').each(function () {
			var typeAheadURL = $(this).attr("data_src_url");
			if (typeAheadURL && typeAheadURL != "") {
				var systemDataJSon = JSON.parse($(this).attr('data_json'));
				if (systemDataJSon) {
					$.each(systemDataJSon, function (i, jsonValue) {
						if (jsonValue.paramFormValue && jsonValue.paramFormValue.trim() != "") {
							var refField = $(parentObj).find('[data-datafield="' + jsonValue.paramFormValue + '"]');
							if (refField != null && refField.length > 0) {
								jsonValue.paramFormValue = refField.attr("name");
							}
						}
					});
					$(this).attr("data_json", (JSON.stringify(systemDataJSon)));
				}
				self.manageTypeAheadField(this, "");
			}
		});
	},
	updateDynamicTypeAheadData(paramId, itemList) {
		var self = this;
		return new Promise(resolve => {
			if (paramId == undefined) {
				paramId = "";
			}
			const promises = []
			var arrayItems = $("input[data_ta_src]");
			var promisedArrayItems = [];
			if (itemList == null) {
				arrayItems.each(function () {
					var promiseObj = self.manageDynamicTypeAheadField(this, paramId);
					if (promiseObj != null) {
						promises.push(promiseObj);
						promisedArrayItems.push(this);
					}
				});
			} else {
				$.each(itemList, function (i, parentObj) {
					$(parentObj).find("[data_src_url]").each(function () {
						var typeAheadURL = $(this).attr("data_src_url");
						if (typeAheadURL && typeAheadURL != "") {
							var systemDataJSon = JSON.parse($(this).attr('data_json'));
							if (systemDataJSon) {
								$.each(systemDataJSon, function (i, jsonValue) {
									if (jsonValue.paramFormValue && jsonValue.paramFormValue.trim() != "") {
										var refField = $(parentObj).find('[data-datafield="' + jsonValue.paramFormValue + '"]');
										if (refField != null && refField.length > 0) {
											jsonValue.paramFormValue = refField.attr("name");
										}
									}
								});
								$(this).attr("data_json", (JSON.stringify(systemDataJSon)));
							}
							var promiseObj = self.manageDynamicTypeAheadField(this, "");
							if (promiseObj != null) {
								promises.push(promiseObj);
								promisedArrayItems.push(this);
							}
						}
					});

				});

			}
			if (promisedArrayItems.length > 0) {
				Promise.all(promises).then((res) => {
					res.forEach((responseData, responseIndex) => {
						var serviceData = [];
						var currentObj = promisedArrayItems[responseIndex];
						var compName = $(currentObj).attr('name');
						var fieldObj = self.getElementByName(compName);
						var dataPrefetch = fieldObj.attr('data_prefetch');
						var dataField = fieldObj.attr('data_field');
						var dispField = fieldObj.attr('data_disp_field');
						var valueField = fieldObj.attr('data_value_field');

						if (dataField == null || dataField == "") {
							dataField = "data";
						}
						/*
						 * Currently in E5 we are using value as disp field and name as
						 * value field.
						 */
						if (dispField == null || dispField == "") {
							dispField = "value";
						}
						if (valueField == null || valueField == "") {
							valueField = "name";
						}

						if (responseData) {
							var resultArray = self.getSplittedResultArray(dataField, responseData);
							if (resultArray != null) {
								$.each(resultArray, function (i, infoData) {
									if (infoData[dispField] && infoData[valueField]) {
										serviceData.push({
											"name": infoData[dispField],
											"value": infoData[valueField],
											"dispField": infoData[valueField] + " - " + infoData[dispField]
										});
									}
								});
							}
						}
						self.getElementByName(compName).attr('data_ta_src', JSON.stringify(serviceData));
						if (dataPrefetch != undefined && dataPrefetch == "true") {
							self.checkForTypeahead(compName);
						}




					})
					return resolve("Success");

				})
			} else {
				return resolve("Success");
			}


		})

	},
	manageDynamicTypeAheadField(currentObj, paramId) {
		var self = this;
		self.destroyTypeaheadElement(currentObj);
		var dataPrefetch = $(currentObj).attr('data_prefetch');
		var compName = $(currentObj).attr('name');

		if (dataPrefetch == undefined || dataPrefetch == "" || dataPrefetch == "false") {
			if (paramId == "") {
				self.getElementByName(compName).attr('data_ta_src', "[]");
				self.bindFieldTypeAheadOnFocus(compName);
				self.checkForTypeahead(compName);
				return null;
			} else {
				return null;
			}
		}


		var systemURL = $(currentObj).attr('data_src_url');
		var systemDataJSon = $(currentObj).attr('data_json');
		if (paramId != "") {
			var hasReference = self.hasFieldCurrentComponentReference(JSON.parse(systemDataJSon), paramId);
			if (!hasReference) {
				return null;
			}
		}
		var typeAheadUpdateRequired = self.checkTypeAheadDynamicData(JSON.parse(systemDataJSon), compName);
		if (!typeAheadUpdateRequired) {
			return new Promise((resolve) => {
				self.getData(constants.BASE_URL + systemURL).then((responseData) => {
					return resolve(responseData);
				}, (error) => { resolve(); });
			});
		}
		else {
			systemDataJSon = JSON.parse(self.getElementByName(compName).attr('data_json'));
			return self.renderDynamicTypeAheadDataField(systemDataJSon, compName);
		}


	},
	renderDynamicTypeAheadDataField(serviceParameters, selectedWidget) {
		var self = this;
		var url = self.updateDynamicURL(serviceParameters, selectedWidget);
		return new Promise((resolve) => {
			self.getData(constants.BASE_URL + url).then((responseData) => {
				return resolve(responseData);
			}, (error) => { resolve(); });
		});
	},
	updateDynamicURL(serviceParameters, selectedWidget) {
		var self = this;
		var esystem = $(`input[name="${selectedWidget}"]`).attr('data_esystem');
		var eAPI = $(`input[name="${selectedWidget}"]`).attr('data_eapi');
		var eAdapter = $(`input[name="${selectedWidget}"]`).attr('data_eadapter');
		var url = "/adapters/" + esystem + "/" + eAPI + "/" + eAdapter;
		$.each(serviceParameters, function (i, value) {
			var paramName = value.paramName;
			var paramValue = value.paramValue;
			if (i == 0) {
				url = url + "?" + paramName + "=" + paramValue;
			} else {
				url = url + "&" + paramName + "=" + paramValue;
			}
		});
		self.getElementByName(selectedWidget).attr('data_src_url', url);
		return url;

	},
	getData(url) {

		return window.fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json; charset=utf-8'
			}
		})
			.then(res => res.json())
			.catch(e => {
			})
	}
}
window.typeahead_object = TypeaheadUtils;
export default TypeaheadUtils;